module.exports = __webpack_public_path__ + "static/media/logo.la-spezia.eb2b6f61.svg";